<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title> Dados do registro </v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-6">
              <v-text-field
                label="Cliente"
                v-model="current.name"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-text-field
                label="Nascimento"
                :value="current.birth | formatDate"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-text-field
                label="CPF/CNPJ"
                v-model="current.cnpx"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-2">
              <v-text-field
                label="RG/IE"
                v-model="current.rgie"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <v-text-field
                label="Telefone"
                v-model="current.telephone"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-4">
              <v-text-field
                label="Celular"
                v-model="current.cellphone"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-4">
              <v-text-field
                label="E-mail"
                v-model="current.email"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from '../../api/index.js';
export default {
  data: function () {
    return {
      current: null,
    };
  },
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/client/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
  },
};
</script>